<div class="clear"></div>
<section class="banner">
	<div class="container py-4">
		<h1>{{this.userUtilsService.selectedEnvironment?.Letter}}PPRA Guidelines</h1>
	</div>
</section>
<div class="clear"></div>
<iframe src="./assets/docs/pguidelines.pdf" frameBorder="0" scrolling="auto" height="100%" width="100%"></iframe>
<div class="clear"></div>